const StatementTypes = {
  Unknown: 0,
  NqiPayeeSpecificFixed: 1,
  NqiPayeeSpecificVariable: 2,
  QiPayeeSpecificVariable: 3,
  QiPooled: 4,
  NqiPooled: 5,
  SimpleWhdStatement: 6,
  DetailedWhdStatement: 7,
  AltWhdStatement: 8,
  PooledWhdStatement: 9
};

StatementTypes.fromString = (str) => {
  const normalized = str.toLowerCase();

  const match = Object.entries(StatementTypes).find(
    ([key, value]) => typeof value === 'number' && key.toLowerCase() === normalized
  );

  return match && match.length > 1 ? match[1] : StatementTypes.Unknown;
};

StatementTypes.getDescription = (type) => {
  switch (type) {
    case 1:
      return 'NQI Payee Specific Fixed';
    case 2:
      return 'NQI Payee Specific Variable';
    case 3:
      return 'QI Payee Specific Variable';
    case 4:
      return 'QI Pooled';
    case 5:
      return 'NQI Pooled';
    case 6:
      return 'Simple Withholding Statement';
    case 7:
      return 'Detailed Withholding Statement';
    case 8:
      return 'Alt Withholding Statement';
    case 9:
      return 'Pooled Withholding Statement';

    default:
      return null;
  }
};

export default StatementTypes;
